/**
* @file 资源管理-司机流水
* */
<template>
  <div id="driverFlowing">
    <custom-table
      ref="customTable"
      has-organization="true"
      :customOptions="customOptions"
      :paging="false"
      :columns="columns"
      
      addText=""
      excel-type="DriverFlowing"
      :summaryList="[
        { name: 'orderFinishNum' },
        { name: 'orderFee', beforeUnit: '￥' },
        { name: 'incomeFee', beforeUnit: '￥' },
        { name: 'settledFee', beforeUnit: '￥' },
        { name: 'balance', beforeUnit: '￥' },
      ]"
    >
      <template slot="customTable-top">
        <custom-radio-date
          @changeFn="changeBulletinFn"
          :radioGroup="[
            { value: 1, label: '昨日' },
            { value: 2, label: '最近7天' },
            { value: 3, label: '最近30天' },
            { value: 4, label: '最近半年' },
            { value: 5, label: '最近一年' },
            { value: 6, label: '从始至终' },
          ]"
        ></custom-radio-date>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
          row.created | filterTime
        }}</template>

        <div v-else-if="item.prop === 'name'" class="avatar-name">
          <img
            class="avatar-img"
            v-if="row.headPortrait"
            :src="mixinQiniuImg(row.headPortrait)"
          />{{ row.name }}
        </div>

        <template
          v-else-if="
            item.prop === 'orderFee' ||
            item.prop === 'incomeFee' ||
            item.prop === 'settledFee' ||
            item.prop === 'balance'
          "
        >
          <span class="util-money" v-if="row[item.prop]">{{
            "￥" + row[item.prop]
          }}</span>
          <span v-if="!row[item.prop]">-</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
import CustomRadioDate from "../../components/customRadioDate1";
export default {
  name: "driver",
  methods: {
    changeBulletinFn(val) {
      this.customOptions.params.timeType = val.timeType;
      this.customOptions.params.startTime = val.startTime;
      this.customOptions.params.endTime = val.endTime;
      this.$nextTick(() => {
        if (this.loadStatus) {
          this.loadStatus = false;
        } else {
          this.$refs.customTable.listFn();
        }
      });
    },
  },
  components: { CustomRadioDate },
  data() {
    return {
      loadStatus: true,
      // 配置项
      customOptions: {
        params: {},
        // 请求的列表url
        url: "/api/v1/manage/flowing/statistics/driver",
        // 请求的参数列表
        setTime: true,
        search: [
          {
            type: "input",
            field: "name",
            name: "真实姓名",
            value: "",
          },
          {
            type: "input",
            field: "phone",
            name: "手机号码",
            value: "",
          },
          {
            type: "select",
            field: "sort",
            name: "排序",
            value: 1,
            option: [
              { label: "完成订单-从高到低", value: 1 },
              { label: "订单流水-从高到低", value: 2 },
              { label: "提成收入-从高到低", value: 3 },
              { label: "已结算金额-从高到低", value: 4 },
              { label: "钱包余额-从高到低", value: 5 },
            ],
          },
        ],
      },
      columns: [
        { prop: "name", label: "真实姓名" },
        { prop: "phone", label: "手机号码" },
        { prop: "orderFinishNum", label: "完成订单" },
        { prop: "orderFee", label: "订单流水" },
        { prop: "incomeFee", label: "提成收入" },
        { prop: "settledFee", label: "已结算金额" },
        { prop: "balance", label: "钱包余额" },
      ],
    };
  },
};
</script>

<style lang="less">
#driverFlowing {
  .avatar-name {
    display: flex;
    align-items: center;

    .avatar-img {
      width: 32px;
      height: 32px;
      background-color: #ccc;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}
</style>
